/**
 * description 多媒体资源路由
 * created by nxf
 * created on 2019-06-22
 */
"use strict";
angular.module("multiMediaResourceRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state('front.resourcectrl.multimediaresource.picture', { //图片素材
        url: "/picture?typename&nodeid&nodename",
        views: {
            'main@front.resourcectrl.multimediaresource': {
                templateUrl: './resourceCenter/multiMediaResource/picture/picture_main_tpl.html',
                controller: 'resCenPictureCtrl'
            }
        }
    }).state('front.resourcectrl.multimediaresource.video',{  //视频素材
        url: "/video?typename&mediaId&hybaseId",
        views:{
            'main@front.resourcectrl.multimediaresource': {
                templateUrl: './resourceCenter/multiMediaResource/video/video_main_tpl.html',
                controller: 'resCenVideoCtrl'
            }

        }

    });
}]);
